import { useCallback, useState } from 'react';
import { DormitoryLegacyHttp } from '@/services';
import { parseError } from '@/utils';

export default function useDormitoryRoomsCapacity() {

  const [roomsCapacity, setRoomsCapacity] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>(null);

  const fetchRoomsCapacity = useCallback(async (dormitoryId: number) => {
    try {
      setError(null);
      setLoading(true);
      setRoomsCapacity([]);
      const res = await DormitoryLegacyHttp.fetchRoomsCapacity(dormitoryId);
      setRoomsCapacity(res?.data?.payload?.roomsCapacity ?? []);
    }
    catch(e) {
      console.error(e);
      setError(parseError(e));
    }
    finally {
      setLoading(false);
    }
  }, []);

  return { roomsCapacity, fetchRoomsCapacity, loading, error };
}
